__turbopack_context__.v({
  "logoImg": "styles-module__my2kXG__logoImg",
});
